module.exports = __webpack_public_path__ + "img/connect-domain-light.2ee20106.svg";